const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`, `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`, 1, 40), undefined, false, false, 1));
            }

            getTemplateName() {
                return `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`;
            }

            getSourceContext() {
                return new this.Source(``, `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`, ``);
            }
        }],
        [40, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']],
                    ['content_end', [this, 'block_content_end']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`Button with a custom icon`);
            }

            block_content_end(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <svg viewBox="0 0 24 24" width="24" height="24" class="c-icon">
      <circle r="8" cx="12" cy="12"></circle>
    </svg>
  `);
            }

            getTemplateName() {
                return `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6');

let template = env.loadTemplate('096fce8ec60fa25c8868630493ed0378b91df59f0019d0e19708e472c50232c6');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/button/demo/icon-button-custom-demo.twig", args: context }
     );
     return rendered;;
};